import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { TtButton } from '@23/react'

import { useConfirmationModal } from '../../../../../global/hooks/useConfirmationModal'

interface MutingVideoConfirmationProps {
  onConfirm: () => void
  onCancel: () => void
}

const MutingVideoConfirmation = ({
  onConfirm,
  onCancel,
}: MutingVideoConfirmationProps) => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <>
      <FormattedMessage defaultMessage="You will not be visible to your audience and speakers" />

      <TtButton
        slot="footer"
        color="primary"
        pill
        onClick={() => {
          onConfirm()
          setIsLoading(true)
        }}
        loading={isLoading}
      >
        <FormattedMessage defaultMessage="Yes, I'm sure" />
      </TtButton>
      <TtButton
        slot="footer"
        color="secondary"
        variant="outline"
        pill
        disabled={isLoading}
        onClick={onCancel}
      >
        <FormattedMessage defaultMessage="Cancel" />
      </TtButton>
    </>
  )
}

const useMutingVideoConfirmation = () => {
  return useConfirmationModal(MutingVideoConfirmation, {
    title: 'Are you sure you want to turn off your webcam?',
  })
}

export { useMutingVideoConfirmation }
